import M from "moment/moment";
import Button from "../../../../modules/commons/Button";
import React from "react";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import * as R from "ramda";
import {defaultTableChange1} from "../../../../modules/custom/customTable";
import FlexView from "react-flexview";
import { ACTIVITY_TYPE } from "../../../common/Constants";

export const formGroupNOSCreate = {
    spbmNo: {value: ""},
    spbmDate: {value: M(new Date()).format("DD-MM-YYYY"), mandatory: true},
    slNo: {value: "", mandatory: true},
    slDate: {value: null, mandatory: true},
    noPolisi: {value: ""},
    invoiceNo: {value: ""},
    poId: {value: ""},
    kodeSupplier: {value: {}, mandatory: true},
    kodeSupplierExpedition: {value: {}},
    description: {value: ""},
    kodeCabang: {value: ""},
    jumlah: {value: 0},
    manual: {value: true},
    details: {value: []},
};

export const tableConfig = {
    nosOptionDetail: (handleOnRowSelected, onChangePage, onChangeRow) => {
        return {
          ...defaultTableChange1(onChangePage, onChangeRow, (e) =>
            handleOnRowSelected(e),
          ),
          selectableRows: true,
          serverSide: false,
        };
    },

    nosOptionCorrection: (onChangePage, onChangeRow) =>({
        ...defaultTableChange1(onChangePage,onChangeRow),
        selectableRows: false,
        serverSide: false,
    }),
}

export const tableColumns = (handleModalDetailVisibility, userAccess) => [
    {
        name: "id",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
            sort: false,
        },
    },
    {
        name: "spbmDate",
        label: "Tgl. SPBM",
        options: {
            sort: false,
        },
    },
    {
        name: "spbmNo",
        label: "No. SPBM",
        options: {
            sort: false,
        },
    },
    {
        name: "slNo",
        label: "No. SL",
        options: {
            sort: false,
        },
    },
    {
        name: "slDate",
        label: "Tanggal SL",
        options: {
            sort: false,
        },
    },
    {
        name: "jumlah",
        label: "Jumlah",
        options: {
            sort: false,
        },
    },
    {
        name: "manual",
        label: "Manual",
        options: {
            sort: false,
        },
    },
    {
        name: "",
        label: "Aksi",
        options: {
            customBodyRender: (_, tableMeta) => {
                return (
                    <FlexView style={{gap:'10px'}}>
                        <Button
                            className="btnAct"
                            onClick={() => handleModalDetailVisibility(tableMeta.rowIndex)}
                        >
                            <i className="fa fa-lg fa-eye" style={{ fontSize: 20, color: "red" }} />
                        </Button>
                        {userAccess?.updateAccess &&
                            <Button
                                className="btnAct"
                                onClick={() => handleModalDetailVisibility(tableMeta.rowIndex, true)}
                            >
                                <i className="fa fa-lg fa-pencil-alt" style={{ fontSize: 20, color: "red" }} />
                            </Button>
                        }
                    </FlexView>
                );
            },
            sort: false,
        },
    },
];

export const tableDetailColumns = {
    detail: [
        {
            name: "kodeVarian",
            label: "Kode Varian",
            options: {
                customBodyRender: (value) => {
                    return value ? value.value : "-";
                },
            }
        },
        {
            name: "namaVarian",
            label: "Nama Varian",
            options: {
                customBodyRender: (value) => {
                    return value ? value : "-";
                }
            }
        },
        {
            name: "frameNumber",
            label: "NoKa",
            options: {
                customBodyRender: (value) => {
                    return value;
                }
            }
        },
        {
            name: "engineNumber",
            label: "NoSin",
            options: {
                customBodyRender: (value) => {
                    return value;
                }
            }
        },
        {
            name: "kodeWarna",
            label: "Kode Warna",
            options: {
                customBodyRender: (value) => {
                    return value ? value.label : "-";
                }
            }
        },
        {
            name: "namaWarnaPabrik",
            label: "Warna",
            options: {
                customBodyRender: (value) => {
                    return value ? value : "-";
                }
            }
        },
        {
            name: "rfsStatus",
            label: "RFS",
            options: {
                customBodyRender: (value) => {
                    return (
                        <SimpleCheckBox
                            id="rfs_status"
                            name="rfsStatus"
                            disabled
                            onChange={()=>{}}
                            checked={!!R.equals(value, "RFS")}
                        />
                    )
                },
            }
        },
        {
            name: "yearManufactured",
            label: "Thn. Prod",
            options: {
                customBodyRender: (value) => {
                    return value ? value : "-";
                }
            }
        },
        {
            name: "kodeLocation",
            label: "Locator",
            options: {
                customBodyRender: (value) => {
                    return value ? value.label : "-";
                }
            }
        },
        {
            name: "numberOfPrint",
            label: "Jml. Print QR",
            options: {
                customBodyRender: (value) => {
                    return !R.isNil(value) ? value : "0";
                }
            }
        },
    ],
    correction: [],
}